export class GetTableContextResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "versionId",
            "baseName": "versionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "generatedAt",
            "baseName": "generatedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "generatedBy",
            "baseName": "generatedBy",
            "type": "string",
            "format": ""
        },
        {
            "name": "summary",
            "baseName": "summary",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "source",
            "baseName": "source",
            "type": "string",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<TableContextColumn>",
            "format": ""
        },
        {
            "name": "notes",
            "baseName": "notes",
            "type": "Array<TableContextNote>",
            "format": ""
        },
        {
            "name": "kinds",
            "baseName": "kinds",
            "type": "TableContextKinds",
            "format": ""
        },
        {
            "name": "segments",
            "baseName": "segments",
            "type": "TableContextSegments",
            "format": ""
        },
        {
            "name": "markdown",
            "baseName": "markdown",
            "type": "string",
            "format": ""
        },
        {
            "name": "stale",
            "baseName": "stale",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "live",
            "baseName": "live",
            "type": "TableLiveView",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableContextResponse.attributeTypeMap;
    }
    constructor() {
    }
}
